import AppWrapper from "AppWrapper";
import { apiClient } from "api";
import React from "react";
import ReactDOM from "react-dom/client";
import { RecoilRoot } from "recoil";

import { ChainlitContext } from "@chainlit/react-client";

import "./index.css";

import { i18nSetupLocalization } from "./i18n";
import { FontSizeProvider } from "@/components/FontSizeProvider";

i18nSetupLocalization();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <ChainlitContext.Provider value={apiClient}>
      <RecoilRoot>
        <FontSizeProvider defaultFontSize="large">
          <AppWrapper />
        </FontSizeProvider>
      </RecoilRoot>
    </ChainlitContext.Provider>
  </React.StrictMode>,
);
